<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>upp-color</h2>
            <p class="demo-description">Reusable color picker with manual hex input and visual HSV selector.</p>

            <div class="demo-section">
                <upp-color
                    [label]="'Background color'"
                    [value]="bgColor"
                    [dataid]="'demo-color-bg'"
                    (Changed)="OnBackgroundChanged($event)"
                ></upp-color>
                <upp-color
                    [label]="'Foreground color'"
                    [value]="fgColor"
                    [dataid]="'demo-color-fg'"
                    (Changed)="OnForegroundChanged($event)"
                ></upp-color>
            </div>

            <div class="preview-card" [style.background]="BackgroundPreview" [style.color]="ForegroundPreview">
                <h3>Live preview</h3>
                <p>bg: {{ bgColor }} · fg: {{ fgColor }}</p>
            </div>
        </div>
    </upp-scrollable>
</div>
